<div
  *ngIf="content?.hasError"
  [ngClass]="{ mfaFailed: content?.pageContent?.mfaFailed }"
  class="form-alert"
  id="formAlertId"
>
  <idp-form-alert
    [showCloseButton]="true"
    [message]="content?.errorMessage"
    [tabIndex]="'-1'"
    (closePopup)="closePopup()"
  ></idp-form-alert>
</div>
<idp-login-header
  [ngClass]="{
    'login-header-margin':
      content.formAttributes.errorAlertBanner &&
      content.formAttributes.submitAttempt
  }"
  [loginHeaderContent]="content.pageContent.pageHeader"
></idp-login-header>

<ng-container
  *ngIf="
    content.formAttributes.submitAttempt &&
    content.formAttributes.errorAlertBanner &&
    content.formAttributes.errorCount
  "
>
  <idp-alert-warning
    #alertWarning
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content.formAttributes.errorCount"
    [errorMessage]="content.pageContent.errors.alertWarning"
  ></idp-alert-warning>
</ng-container>
<form
  [formGroup]="resetPasswordForm"
  id="resetPasswordForm"
  class="forgot-password"
  (ngSubmit)="onSubmit()"
>
  <div class="forgot-password__content">
    <div
      class="forgot-password__content__user-name"
      [ngClass]="{
        'forgot-password__content__user-name__mfa': content.formAttributes.isMfa
      }"
    >
      <idp-input
        [labelTxt]="content.pageContent.userIdLabel"
        formControlName="userId"
        id="userId"
        (keyup)="onChange('userId')"
      ></idp-input>
      <!-- TODO: replace with error mesage component-->
      <div *ngIf="showErrorMessageUserId" class="error-message__userId">
        <span
          class="errorMessageText"
          [innerHTML]="content.pageContent.errors.userIdErrorMessage"
        ></span>
      </div>
      <ng-container *ngIf="content.formAttributes.isMfa">
        <a
          class="forgot-password__content__forgot-login-navigate"
          aria-label="Forgot Login Modal"
          href="javascript:void(0)"
          (click)="displayNextView('forgotLogin')"
        >
          {{ content.pageContent.forgotLogin }}
          <span class="sr-only">
            Navigate to, {{ content.pageContent.forgotLogin }} Modal
          </span>
        </a>
      </ng-container>
    </div>

    <div
      class="forgot-password__content__first-name"
      [ngClass]="{
        'forgot-password__content__first-name__mfa':
          content.formAttributes.isMfa
      }"
    >
      <idp-input
        [labelTxt]="content.pageContent.firstNameLabel"
        formControlName="firstName"
        id="firstName"
        (keyup)="onChange('firstName')"
      ></idp-input>
      <div *ngIf="showErrorMessageFirstName" class="error-message__firstname">
        <span
          class="errorMessageText"
          [innerHTML]="content.pageContent.errors.firstNameErrorMessage"
        ></span>
      </div>
    </div>
    <div
      class="forgot-password__content__last-name"
      [ngClass]="{
        'forgot-password__content__last-name__mfa': content.formAttributes.isMfa
      }"
    >
      <idp-input
        [labelTxt]="content.pageContent.lastNameLabel"
        formControlName="lastName"
        id="lastName"
        (keyup)="onChange('lastName')"
      ></idp-input>
      <div *ngIf="showErrorMessageLastName" class="error-message__lastname">
        <span
          class="errorMessageText"
          [innerHTML]="content.pageContent.errors.lastNameErrorMessage"
        ></span>
      </div>
    </div>
  </div>
  <div class="forgot-password__submit-btn">
    <idp-button
      [label]="content.pageContent.buttonLabel"
      [elementType]="'submit'"
      [size]="'full-width'"
      [customClass]="'resetPasswordButton'"
      [disabled]="content.formAttributes.disableActionButton"
    ></idp-button>
  </div>
</form>
